/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Discount_RangeInputs */

const vi_form_err_discount_range = /** @type {(inputs: Form_Err_Discount_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiết khấu phải từ 0 đến 100`)
};

/**

* @param {Form_Err_Discount_RangeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_discount_range = /** @type {((inputs?: Form_Err_Discount_RangeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Discount_RangeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_discount_range(inputs)
});